import { ActionsHook } from "@/lib/Components/Actions/ActionGroupButtons";
import { PaidDriverListItem } from "@/app/ProDrivers/Drivers/GraphQL/proDriverListQuery";
import { useDialog } from "@/lib/Components/Dialog/Hooks/useDialog";
import { UpdateProDriverDialog } from "@/app/ProDrivers/Drivers/Components/Dialogs/UpdateProDriverDialog";
import { PencilIcon, TrashIcon } from "@heroicons/react/20/solid";
import { useGqlMutation } from "@/lib/GraphQLCodegen/fetcher";
import { deleteProDriverMutation } from "@/app/ProDrivers/Drivers/GraphQL/proDriverMutations";

export function useProDriverActions(): ActionsHook<PaidDriverListItem> {
  const { open } = useDialog(UpdateProDriverDialog);
  const { mutateAsync: deleteRecord } = useGqlMutation(deleteProDriverMutation);

  return (model) => {
    return [
      {
        label: "Actions",
        items: [
          {
            actions: [
              {
                Icon: PencilIcon,
                label: "Edit",
                handleAction: () => {
                  open({
                    paidDriverId: model.id,
                  });
                },
              },
            ],
          },
          {
            actions: [
              {
                Icon: TrashIcon,
                label: "Delete",
                color: "red",
                handleAction: () => {
                  return deleteRecord({
                    id: model.id,
                  });
                },
              },
            ],
          },
        ],
      },
    ];
  };
}
